import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c83548c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-10 col-lg-4 p-3 bg-light custom-modal m-auto rounded-3 mt-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row pt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Vous souhaitez nous quitter? 😭")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row pt-3 px-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col mx-2 text-start" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("strong", null, [
        /*#__PURE__*/_createElementVNode("u", null, "Attention!")
      ]),
      /*#__PURE__*/_createTextVNode(" La suppression de votre compte entrainera la suppression de toutes vos données personnelles de manière irreversible. Il ne vous sera plus possible de vous connecter et d'accéder notamment à vos factures. ")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, " Pour à nouveau participer aux courses, il faudra vous réinscrire et repayer les droits d'admission (sauf dérogation). "),
    /*#__PURE__*/_createElementVNode("p", null, " Si vous souhaitez poursuivre la suppression de votre compte, veuillez renseignez votre mot de passe ci-dessous, puis cliquer sur le bouton Supprimer. ")
  ])
], -1))
const _hoisted_4 = { class: "row text-start" }
const _hoisted_5 = { class: "col m-2" }
const _hoisted_6 = { class: "row px-2 fw-bold" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-danger" }, "Mauvais mot de passe", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "row px-2 fw-bold" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-danger" }, "Une erreur est survenue", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { action: "" }
const _hoisted_13 = { class: "row p-2 fw-bold" }
const _hoisted_14 = { class: "col form-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputNewPassword" }, " Mot de passe:", -1))
const _hoisted_16 = { class: "row mt-4" }
const _hoisted_17 = { class: "col form-group text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "backdrop overflow-scroll",
    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("div", _hoisted_6, _hoisted_8, 512), [
            [_vShow, _ctx.wrongPassword]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_9, _hoisted_11, 512), [
            [_vShow, _ctx.errorAPI]
          ]),
          _createElementVNode("form", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: "form-control",
                  id: "inputNewPassword",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
                  minlength: "8",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.password]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  class: "btn btn-danger",
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteAccount && _ctx.deleteAccount(...args)))
                }, " Supprimer ")
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}